import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index'

Vue.use(Router)

export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  { path: '/layout', name: 'Layout', component: Layout },
  {path: '/bareSoilDistribution', component: () => import('@/views/weixin/bareSoilDistribution')},
]

export const asyncRouterMap = [
  {
    path: '/',
    component: Layout,
    redirect: '/image',
    name: '',
    meta: {title: '', icon: ''},
    children: [
      {
        path: 'image',
        name: 'image',
        redirect: '/image/imageList',
        component: () => import('@/views/image/index'),
        meta: {title: '影像列表', icon: 'product-list'},
        children: [
          {
            path: 'imageList',
            name: 'imageList',
            component: () => import('@/views/image/imageList'),
            meta: {title: '遥感数据', icon: 'product-list'}
          },
          {
            path: 'imageDetail',
            name: 'imageDetail',
            component: () => import('@/views/image/imageDetail'),
            meta: {title: '多期遥感', icon: 'product-list'}
          }
        ]
      },
      {
        path: 'topic',
        name: 'topic',
        component: () => import('@/views/topic/index'),
        meta: {title: '专题监测', icon: 'product-list'}
      },
      {
        path: 'ledger',
        name: 'ledger',
        component: () => import('@/views/ledger/index'),
        meta: {title: '斑块台账', icon: 'product-list'}
      },
      {
        path: 'contrast',
        name: 'contrast',
        component: () => import('@/views/contrast/index'),
        meta: {title: '对比', icon: 'product-list'}
      },
      {
        path: 'criterion',
        name: 'criterion',
        component: () => import('@/views/criterion/index'),
        meta: {title: '工作规范', icon: 'product-list'}
      },
      {
        path: 'manage',
        name: 'manage',
        redirect: '/manage/user',
        component: () => import('@/views/manage/index'),
        meta: {title: '权限管理', icon: 'product-list'},
        children: [
          {
            path: 'user',
            name: 'user',
            component: () => import('@/views/manage/users'),
            meta: {title: '用户管理', icon: 'product-list'}
          },
          {
            path: 'role',
            name: 'role',
            component: () => import('@/views/manage/role'),
            meta: {title: '角色管理', icon: 'product-list'}
          },
          {
            path: 'menu',
            name: 'menu',
            component: () => import('@/views/manage/menus/index'),
            meta: {title: '菜单管理', icon: 'product-list'}
          },
          {
            path: 'resource',
            name: 'resource',
            component: () => import('@/views/manage/resources/index'),
            meta: {title: '资源管理', icon: 'product-list'}
          },
          {
            path: 'editCriterion',
            name: 'editCriterion',
            component: () => import('@/views/manage/editCriterion/index'),
            meta: {title: '工作规范', icon: 'product-list'}
          },
          {
            path: 'uploadImg',
            name: 'uploadImg',
            component: () => import('@/views/manage/uploadImg/index'),
            meta: {title: '上传影像', icon: 'product-list'}
          },
          {
            path: 'uploadFile',
            name: 'uploadFile',
            component: () => import('@/views/manage/uploadFile/index'),
            meta: {title: '上传资料', icon: 'product-list'}
          },
          {
            path: 'address',
            name: 'address',
            component: () => import('@/views/manage/address/index'),
            meta: {title: '地址解析', icon: 'product-list'}
          }
        ]
      }

    ]
  }
]
export default new Router({
  mode: 'hash',
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js